import React, { useState } from 'react';
import './CacheOption.css';

const CacheOption = ({ value, onChange, disabled = false }) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="cache-option">
      <div className="cache-toggle">
        <label className="cache-label">
          <input
            type="checkbox"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            className="cache-checkbox"
          />
          <span className="cache-text">
            🚀 Use intelligent caching
          </span>
          <button 
            type="button"
            className="info-btn-inline"
            onClick={() => setShowInfo(!showInfo)}
            title="Learn about caching"
          >
            ⓘ
          </button>
        </label>
      </div>

      {showInfo && (
        <div className="cache-info">
          <h4>💾 Intelligent Caching System</h4>
          
          <div className="cache-benefits">
            <h5>✨ Benefits:</h5>
            <ul>
              <li>⚡ Instant results for exact matches</li>
              <li>💰 Reduced costs (no redundant LLM calls)</li>
              <li>📊 Smart suggestions for similar ideas (85%+ match)</li>
              <li>🔄 Auto-refresh after 1 hour</li>
            </ul>
          </div>

          <div className="cache-how-it-works">
            <h5>🔍 How it works:</h5>
            <ol>
              <li><strong>Exact Match:</strong> Returns cached report instantly if found</li>
              <li><strong>Similar Match:</strong> Shows top 5 similar reports for review</li>
              <li><strong>No Match:</strong> Generates fresh report and caches it</li>
            </ol>
          </div>

          <div className="cache-recommendation">
            <p>
              <strong>💡 Recommendation:</strong> Keep caching enabled for faster results 
              and cost savings. Only disable if you need a fresh analysis for a 
              rapidly changing topic.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CacheOption;
